import React from 'react';

export const VideoLibrary = (props) => (
  <svg fill="none" {...props}>
    <path
      d="M20 30H10v70c0 5.5 4.5 10 10 10h70v-10H20V30zm80-20H40c-5.5 0-10 4.5-10 10v60c0 5.5 4.5 10 10 10h60c5.5 0 10-4.5 10-10V20c0-5.5-4.5-10-10-10zm0 70H40V20h60v60zM60 27.5v45L90 50 60 27.5z"
      fill="#EAEAEA"
    />
  </svg>
);

export const Exit = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.375 20.7578H5.375C4.84457 20.7578 4.33586 20.5471 3.96079 20.172C3.58571 19.797 3.375 19.2882 3.375 18.7578V4.75781C3.375 4.22738 3.58571 3.71867 3.96079 3.3436C4.33586 2.96853 4.84457 2.75781 5.375 2.75781H9.375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.375 16.7578L21.375 11.7578L16.375 6.75781"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.375 11.7578H9.375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
